import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

function PaymentViewCounter({ paymentData }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        gap: "12px",
        flexWrap: "wrap",
        justifyContent: {
          xs: "center",
          sm: "flex-start",
        },
        margin: {
          xs: "4px 0",
          sm: "none",
        },
      }}
    >
      <Box
        tag={"payment-name"}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          padding: "20px",
          width: { xs: "100%", sm: "136px" },
          height: "132px",
          backgroundColor: theme.palette.neutral[800],
          borderRadius: "12px",
        }}
      >
        <Typography variant="h6" color={"white"} textAlign={"center"}>
          {paymentData?.name}
        </Typography>
      </Box>
      <Box
        tag={"card"}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "center",
          gap: "12px",
          padding: "20px",
          width: "fit-content",
          height: "132px",
          backgroundColor: "#f491021a",
          borderRadius: "12px",
        }}
      >
        <img src="/assets/payment.svg" alt="payment-icon" />
        <Box sx={{ display: "flex", gap: "4px", alignItems: "end" }}>
          <Typography
            variant="h4"
            fontWeight={700}
            color={theme.palette.neutral[900]}
            textAlign={"center"}
          >
            {Number(paymentData?.totalFinalAmount)
              .toFixed(3)
              .replace(/\.?0+$/, "")}
          </Typography>
          <Typography
            variant="body2"
            color={theme.palette.neutral[800]}
            textAlign={"center"}
          >
            د.ك
          </Typography>
        </Box>
        <Typography
          variant="body2"
          color={theme.palette.neutral[700]}
          textAlign={"center"}
        >
          المبلغ النهائي
        </Typography>
      </Box>
      {Object.entries(paymentData?.viewTypeCounts).map(([type, count], i) => {
        let iconName;
        if (type == "كراسي المغامرة") {
          iconName = "Chair";
        } else if (type == "كراسي الراحة") {
          iconName = "Headset";
        } else {
          iconName = "Other";
        }

        return (
          <Box
            key={i}
            tag={"view-card"}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
              gap: "12px",
              padding: "20px",
              width: "fit-content",
              height: "132px",
              backgroundColor: "#f491021a",
              borderRadius: "12px",
            }}
          >
            <Box sx={{ display: "flex", width: "40px", height: "40px" }}>
              <img
                src={`/assets/${iconName}.svg`}
                alt="payment-icon"
                style={{ fill: theme.palette.primary[600] }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: "4px", alignItems: "end" }}>
              <Typography
                variant="h4"
                fontWeight={700}
                color={theme.palette.neutral[900]}
                textAlign={"center"}
              >
                {count}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              color={theme.palette.neutral[700]}
              textAlign={"center"}
            >
              عدد {type}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default PaymentViewCounter;
